import Vue from 'vue'
import Router from 'vue-router'
import{_import} from '@/utils';
Vue.use(Router);
const IS_DEV = process.env.NODE_ENV === 'development';
export default new Router({
  mode: IS_DEV ? 'hash':'history',
  routes: [
    {
      path: '/',
      redirect: '/errorPage'
    },
    {
      path: '/errorPage',// 默认首页/404页
      name: 'errorPage',
      component: _import('error/errorPage')
    },
    {
      path: '/2022/',
      name: '2022',// 2022注册宣传
      component: _import('2022/index')
    },
    {
      path: '/2022idcard/',
      name: '2022idcard',// 2022注册宣传
      component: _import('2022idcard/index')
    },
    {
      path: '/downTransferPage/:appId/:aid',
      name: 'downTransferPage',// 下载中转地址
      component: _import('downTransfer/downTransferPage')
    },
    {
      path: '/downpage',
      name: 'downPage',// 下载中转地址
      component: _import('downPage/index')
    },
    {
      path: '/downhtml',
      name: 'downH5',// 下载中转地址
      component: _import('downH5/index')
    },
    {
      path: '/shareQrcode', // 分享好友
      name: 'shareQrcode',
      component: _import('shareQrcode'),
      meta: {
        title: '分享二维码',
      }
    }, 
    {
      path: '/shareQrcodeByWorldCup', // 世界杯分享好友
      name: 'shareQrcodeByWorldCup',
      component: _import('shareQrcodeByWorldCup'),
      meta: {
        title: '分享',
      }
    }, 
    {
      path:'/testflight', //TF
      name:'testFlight',
      component:_import('testFlight'),
      mata:{
        title:'TF教程'
      }
    }, 
    {
      path:'/tutorial', //TF
      name:'tutorial',
      component:_import('testFlight/component/tutorial'),
      mata:{
        title:'TF教程'
      }
    },
    {
      path:'/generateQrcode', //TF
      name:'generateQrcode',
      component:_import('generateQrcode'),
      mata:{
        title:'二维码分享'
      }
    },
    {
      path:'/generateGroupQrcode', //TF
      name:'generateGroupQrcode',
      component:_import('generateGroupQrcode'),
      mata:{
        title:'二维码分享'
      }
    },
    {
      path: '/predict', // 预测
      name: 'predict',
      component: _import('predict'),
      meta: {
        title: '2020欧洲杯冠军之路',
        keepAlive:true
      }
    },
    {
      path: '/predictTree',  //預測樹
      name: 'predictTree',
      component: _import('predictTree'),
      meta: {
        title: '2020欧洲杯冠军之路',
      }
    },
    {
      path: '/predict2026', // 2026预测
      name: 'predict2026',
      component: _import('predict2026'),
      meta: {
        title: '2026世界杯冠军之路',
        keepAlive:true
      }
    },
    {
      path: '/registerByActivity',  //2026預測樹注册
      name: 'registerByActivity',
      component: _import('registerByActivity'),
      meta: {
        title: '注册落地页',
      }
    },
    {
      path: '/predictTree2026',  //2026預測樹
      name: 'predictTree2026',
      component: _import('predictTree2026'),
      meta: {
        title: '2026世界杯冠军之路',
      }
    },
    {
      path: '/predictTree16',  //2026預測樹16强
      name: 'predictTree16',
      component: _import('predictTree16'),
      meta: {
        title: '2026世界杯冠军之路',
      }
    },
    {
      path: '/leitai',
      name: 'leitai',// 擂台赛活动
      component: _import('leitai')
    },
    {
      path: '/winnerRanking',
      name: 'winnerRanking',// 风云榜
      component: _import('winnerRanking')
    },
    {
      path: '/dazhuanpan',  //
      name: 'dazhuanpan',// 大转盘
      component: _import('dazhuanpan')
    },
    {
      path: '/dazhuanpanNew',  //
      name: 'dazhuanpanNew',// 大转盘新
      component: _import('dazhuanpanNew')
    },
    {
      path: '/rankingListPage',  //
      name: 'rankingListPage',// 连红英雄榜
      component: _import('rankingListPage')
    },
    {
      path: '/heroRanking',  //
      name: 'heroRanking',// 发单英雄榜
      component: _import('heroRanking')
    },
    {
      path:'/zhucesong', // 注册送
      name:'zhucesong',
      component:_import('zhucesong')
    },
    {
      path:'/zhucesongfx', // 注册送
      name:'zhucesongfx',
      component:_import('zhucesong/shareQrcode')
    },
    {
      path:'/signInLottery', // 邀请大转盘弹窗
      name:'signInLottery',
      component:_import('signInLottery')
    },
    {
      path:'/signRigister', // 签到邀请注册
      name:'signRigister',
      component:_import('signRigister')
    },
    {
      path: '/yaoqingzhucesong',  //
      name: 'yaoqingzhucesong',// 邀请注册
      component: _import('yaoqingzhucesong'),
      redirect: '/yaoqingzhucesong/yaoqing',
      children: [
        {
          path: '/yaoqingzhucesong/yaoqing',  //邀请页
          name: 'yaoqing',
          component: _import('yaoqingzhucesong/components/yaoqing'),
        },
        {
          path: '/yaoqingzhucesong/fenxiang',  // 分享页
          name: 'fenxiang',
          component: _import('yaoqingzhucesong/components/fenxiang')
        },
        {
          path: '/yaoqingzhucesong/zhuce',  // 注册页
          name: 'zhuce',
          component: _import('yaoqingzhucesong/components/zhuce')
        }
      ]
    },
    {
      path:'/attendance', // 签到
      name:'attendance',
      component:_import('attendance')
    },
    {
      path:'/questionnaire', // 
      name:'questionnaire',
      component:_import('questionnaire'),
      // redirect: '/questionnaire/questions',
      // children: [
      //   {
      //     path: '/questionnaire/questions',  //
      //     name: 'questions',
      //     component: _import('questionnaire/questions'),
      //   },
      //   {
      //     path: '/questionnaire/result',  // 
      //     name: 'result',
      //     component: _import('questionnaire/result')
      //   },
      // ]
    },
    {
      path: '/nbaPlayoffs',  //NBA預測樹
      name: 'nbaPlayoffs',
      component: _import('nbaPlayoffs'),
      meta: {
        title: 'NBA',
      }
    },
    {
      path: '/communityShare',  //社区分享
      name: 'communityShare',
      component: _import('communityShare'),
      meta: {
        title: 'communityShare',
      }
    },
    {
      path: '/rewardRanking',  //社区分享
      name: 'rewardRanking',
      component: _import('rewardRanking'),
      meta: {
        title: 'rewardRanking',
      }
    },
    {
      path: '/weekendKoi',  //周末锦鲤
      name: 'weekendKoi',
      component: _import('weekendKoi'),
      meta: {
        title: '周末锦鲤',
      }
    },
    {
      path:'/weekendKoiRigister', // 周末锦鲤签到邀请注册
      name:'weekendKoiRigister',
      component:_import('weekendKoiRigister')
    },
    {
      path: '/scoreGuessing',  // 世界杯竞猜
      name: 'scoreGuessing',
      component: _import('scoreGuessing'),
      meta: {
        title: '绿茵竞猜-猜比分领红包',
      }
    },
    {
      path: '/scoreGuessingRegister',  // 猜比分注册
      name: 'scoreGuessingRegister',
      component: _import('scoreGuessingRegister'),
      meta: {
        title: '猜比分注册',
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js